import Plyr from 'plyr';

export default class Video {

    constructor(root) {
        this.container = root;
        this.frameContainer = root.querySelector('.frame');
        this.posterContainer = root.querySelector('.poster');
        this.overlay = root.querySelector('.overlay');
        this.startButton = this.overlay.querySelector('.play-button');
        this.plyrPoster = root.querySelector('.plyr__poster');

        this.isReady = false;

        this.player = new Plyr(this.frameContainer, {
            ratio: '16:9',
            controls:[
                'play', // Play/pause playback
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'captions', // Toggle captions
                'fullscreen', // Toggle fullscreen
            ],
            playsinline: true,
            hideControls: false,
        });

        this.player.on('ready', () => {this.isReady = true}); //blah
        this.startButton.addEventListener('click', () => this.handleClick(this));
    }

    handleClick(instance) {
        if(!instance.isReady) return;

        instance.disableOverlay();
        instance.player.play()
        this.player.toggleControls(true);
    }

    disableOverlay() {
        this.startButton.style.display = 'none';
        this.posterContainer.style.display = 'none';
        this.overlay.style.display = 'none';
        if(this.container.querySelector('.plyr__poster')) {
            this.container.querySelector('.plyr__poster').style.display = 'none';
            this.container.querySelector('.plyr__poster').style.pointerEvents = 'none';
        }
    }

}